import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop: React.FC = ({children}) => {
  const { pathname } = useLocation();
  const scrollAttempts = useRef(0);
  const maxScrollAttempts = 5;

  useEffect(() => {
    // Reset scroll attempts counter on new route
    scrollAttempts.current = 0;

    // Function to attempt scroll with progressive timeouts
    const attemptScroll = () => {
      if (scrollAttempts.current >= maxScrollAttempts) return;
      
      scrollAttempts.current += 1;
      
      // Calculate timeout with exponential backoff (150ms, 300ms, 600ms, etc.)
      const timeout = 150 * Math.pow(2, scrollAttempts.current - 1);
      
      const timeoutId = setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        
        // Check if we need another attempt
        if (window.pageYOffset > 0 && scrollAttempts.current < maxScrollAttempts) {
          attemptScroll();
        }
      }, timeout);
      
      return timeoutId;
    };

    // Start the first attempt
    const timeoutId = attemptScroll();
    
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [pathname]);

  return <>{children}</>;
};
